import React from 'react';
import { Store, Clock, Search, CheckCircle2, XCircle, Ban, FileEdit } from 'lucide-react';

export const SELLER_STATUS = {
  draft: { label: 'Brouillon', cls: 'bg-gray-100 text-gray-700 border-gray-200', icon: FileEdit },
  pending: { label: 'Soumis — en attente', cls: 'bg-amber-50 text-amber-800 border-amber-200', icon: Clock },
  under_review: { label: 'En cours d\u2019examen', cls: 'bg-blue-50 text-blue-800 border-blue-200', icon: Search },
  approved: { label: 'Approuvé', cls: 'bg-green-50 text-green-800 border-green-200', icon: CheckCircle2 },
  rejected: { label: 'Refusé', cls: 'bg-red-50 text-red-800 border-red-200', icon: XCircle },
  suspended: { label: 'Suspendu', cls: 'bg-red-100 text-red-900 border-red-300', icon: Ban },
};

export const SellerStatusBadge = ({ status, size = 'sm' }) => {
  const s = SELLER_STATUS[status] || SELLER_STATUS.draft;
  const Icon = s.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 ${size === 'lg' ? 'py-1 text-sm' : 'py-0.5 text-xs'} font-semibold ${s.cls}`} data-testid={`seller-status-${status}`}>
      <Icon size={size === 'lg' ? 15 : 12} /> {s.label}
    </span>
  );
};

export const SellerEmptyHero = ({ onStart, busy }) => (
  <div className="rounded-2xl bg-[#0e0e10] text-white p-8 sm:p-10 relative overflow-hidden" data-testid="seller-hero">
    <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-orange-500/20 blur-3xl" />
    <Store size={34} className="text-orange-400 mb-4" />
    <h2 className="text-2xl sm:text-3xl font-black tracking-tight">Vendez vos pièces d&rsquo;occasion sur OTOPIECES</h2>
    <p className="mt-3 text-gray-300 max-w-xl text-sm sm:text-base">Marketplace réservée aux casses automobiles et aux professionnels de la pièce d&rsquo;occasion. Chaque vendeur est vérifié et approuvé manuellement par notre équipe.</p>
    <ul className="mt-5 grid sm:grid-cols-3 gap-3 text-sm text-gray-200">
      <li className="rounded-xl bg-white/5 border border-white/10 p-3">1. Renseignez votre entreprise</li>
      <li className="rounded-xl bg-white/5 border border-white/10 p-3">2. Transmettez vos justificatifs</li>
      <li className="rounded-xl bg-white/5 border border-white/10 p-3">3. Validation sous 3 jours ouvrés</li>
    </ul>
    <button type="button" onClick={onStart} disabled={busy} className="mt-6 inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 px-6 py-3 font-bold transition-colors disabled:opacity-60" data-testid="seller-start-btn">
      Déposer ma candidature
    </button>
  </div>
);
